import { supabase } from '../services/supabase/client';
import { getAttribution } from './attribution';

const CONSENT_KEY = 'cookie_consent';

function hasPixelConsent() {
  return localStorage.getItem(CONSENT_KEY) === 'accepted';
}

export function trackPixelEvent(eventName, params) {
  if (!hasPixelConsent() || !window.fbq) return;
  window.fbq('track', eventName, params);
}

export function trackPixelCustomEvent(eventName, params) {
  if (!hasPixelConsent() || !window.fbq) return;
  window.fbq('trackCustom', eventName, params);
}

function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function generateEventId() {
  return window.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

// Fires a standard event on both the browser Pixel (if consent + fbq are
// available) and the meta-capi-event Supabase function (server-side,
// always), sharing one event_id so Meta deduplicates the pair instead of
// counting them as two conversions. Campaign attribution (utm_*, fbc)
// captured at landing (see attribution.js) rides along on every event.
export async function trackConversionEvent(eventName, { pixelParams = {}, userData = {} } = {}) {
  const eventId = generateEventId();
  const attribution = getAttribution();

  const customData = { ...pixelParams };
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach((key) => {
    if (attribution[key]) customData[key] = attribution[key];
  });

  if (hasPixelConsent() && window.fbq) {
    window.fbq('track', eventName, customData, { eventID: eventId });
  }

  try {
    await supabase.functions.invoke('meta-capi-event', {
      body: {
        event_name: eventName,
        event_id: eventId,
        event_source_url: window.location.href,
        custom_data: customData,
        user_data: {
          ...userData,
          fbp: getCookie('_fbp'),
          fbc: getCookie('_fbc') || attribution.fbc,
        },
      },
    });
  } catch (error) {
    console.error('[metaPixel] Conversions API event failed:', eventName, error);
  }
}
